export const SLOT_TIMES = [
    "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
    "12:00", "12:30", "13:00", "13:30", "14:00", "14:30",
    "15:00", "15:30", "16:00", "16:30",
];

const DAY_FMT = new Intl.DateTimeFormat("en-GB", { weekday: "short" });
const DATE_FMT = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short" });

export function buildDays() {
    const days = [];
    const d = new Date();
    d.setDate(d.getDate() + 1);
    while (days.length < 7) {
        const dow = d.getDay();
        if (dow !== 0 && dow !== 6) {
            days.push({
                iso: d.toISOString().slice(0, 10),
                weekday: DAY_FMT.format(d),
                label: DATE_FMT.format(d),
            });
        }
        d.setDate(d.getDate() + 1);
    }
    return days;
}

// Deterministic "booked" pattern — stable per day+slot so the page looks
// busy without random flicker between renders.
export function isTaken(dayIso, slotIndex) {
    let h = 0;
    for (let i = 0; i < dayIso.length; i++) h = (h * 31 + dayIso.charCodeAt(i)) % 997;
    return (h + slotIndex * 17) % 10 < 3;
}
